import React from 'react';
import { Link } from 'react-router-dom';

export default function NavBarElement({
  path,
  text,
  handleClick,
  id,
  customStyle = '',
}) {
  return (
    <li
      className={
        customStyle ? customStyle : 'ml-4 hover:border-b border-yellow-500'
      }
    >
      <Link
        onClick={(e) => {
          e.preventDefault();
          handleClick(id);
        }}
        className='md:p-2  block hover:text-yellow-500 '
        to={path}
      >
        {text}
      </Link>
    </li>
  );
}
